const keychain = {
  ACCESSIBLE: {},
  SECURITY_LEVEL: {},
  BIOMETRY_TYPE: null,
  setGenericPassword: async () => true,
  getGenericPassword: async () => false,
  resetGenericPassword: async () => true,
  setInternetCredentials: async () => true,
  getInternetCredentials: async () => false,
  resetInternetCredentials: async () => true,
  hasInternetCredentials: async () => false,
  getSupportedBiometryType: async () => null,
  canImplyAuthentication: async () => false
};

export default keychain;
